// Module
var code = "<div class=\"wa-table-container\"> <div class=\"js-region-wa-table\"></div> <div class=\"js-region-wa-table-footer\"></div> </div> ";
// Exports
export default code;